/* unplugin-vue-components disabled */import script from "./XSearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./XSearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./XSearchForm.vue?vue&type=style&index=0&id=68d5b91c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d5b91c"]])

export default __exports__